// extracted by mini-css-extract-plugin
export default {"container":"ordersummary_container__vrmKZ","sumRow":"ordersummary_sumRow__dpayP","sumLabel":"ordersummary_sumLabel__RqwP9","sumItem":"ordersummary_sumItem__am90w"};